import { render, staticRenderFns } from "./Foro.vue?vue&type=template&id=f2b1e5dc&scoped=true&"
import script from "./Foro.vue?vue&type=script&lang=js&"
export * from "./Foro.vue?vue&type=script&lang=js&"
import style0 from "./Foro.vue?vue&type=style&index=0&id=f2b1e5dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b1e5dc",
  null
  
)

export default component.exports